/**
 * GraphQL documents for hockey challenge via the federated gateway.
 * Reads hang off `me`; mutations are root fields.
 */

export const QUERIES = {
  players: `
    query HockeyPlayers($input: HockeyMockInput) {
      me {
        hockeyPlayers(input: $input) { code data }
      }
    }
  `,
  pickHistory: `
    query HockeyPickHistory($input: HockeyMockInput) {
      me {
        hockeyPickHistory(input: $input) { code data }
      }
    }
  `,
  user: `
    query HockeyUser {
      me {
        hockeyUser { code data }
      }
    }
  `,
  userStats: `
    query HockeyUserStats($input: HockeyMockInput) {
      me {
        hockeyUserStats(input: $input) { code data }
      }
    }
  `,
  leaderboard: `
    query HockeyChallengeLeaderboard($input: HockeyLeaderboardInput) {
      me {
        hockeyChallengeLeaderboard(input: $input) { code data }
      }
    }
  `,
  leaderboardLocal: `
    query HockeyChallengeLeaderboardLocal($input: HockeyLeaderboardInput) {
      me {
        hockeyChallengeLeaderboardLocal(input: $input) { code data }
      }
    }
  `,
  seasonLeaderboard: `
    query HockeySeasonLeaderboard($input: HockeyLeaderboardInput) {
      me {
        hockeySeasonLeaderboard(input: $input) { code data }
      }
    }
  `,
  seasonLeaderboardLocal: `
    query HockeySeasonLeaderboardLocal($input: HockeyLeaderboardInput) {
      me {
        hockeySeasonLeaderboardLocal(input: $input) { code data }
      }
    }
  `,
  postSeasonLeaderboard: `
    query HockeyPostseasonLeaderboard($input: HockeyLeaderboardInput) {
      me {
        hockeyPostseasonLeaderboard(input: $input) { code data }
      }
    }
  `,
  postSeasonLeaderboardLocal: `
    query HockeyPostseasonLeaderboardLocal($input: HockeyLeaderboardInput) {
      me {
        hockeyPostseasonLeaderboardLocal(input: $input) { code data }
      }
    }
  `,
  quiz: `
    query SkillTestingQuestionStatus($eventId: String!) {
      me {
        skillTestingQuestionStatus(eventId: $eventId) {
          passed
          lockedOut
        }
      }
    }
  `,
  notification: `
    query HockeyRemindersOptIn {
      me {
        hockeyRemindersOptIn
      }
    }
  `,
};

export const MUTATIONS = {
  playerPicks: `
    mutation SubmitHockeyPicks($input: SubmitHockeyPicksInput!) {
      submitHockeyPicks(input: $input) { code data }
    }
  `,
  user: `
    mutation UpdateHockeyUser($input: UpdateHockeyUserInput!) {
      updateHockeyUser(input: $input) { code data }
    }
  `,
  quiz: `
    mutation RecordSkillTestingQuestion($input: RecordSkillTestingQuestionInput!) {
      recordSkillTestingQuestion(input: $input) {
        passed
        lockedOut
      }
    }
  `,
  notification: `
    mutation UpdateHockeyReminders($input: UpdateHockeyRemindersInput!) {
      updateHockeyReminders(input: $input)
    }
  `,
};

/** me-field name for each Boom read route */
export const ME_BOOM_FIELD = {
  players: 'hockeyPlayers',
  pickHistory: 'hockeyPickHistory',
  user: 'hockeyUser',
  userStats: 'hockeyUserStats',
  leaderboard: 'hockeyChallengeLeaderboard',
  leaderboardLocal: 'hockeyChallengeLeaderboardLocal',
  seasonLeaderboard: 'hockeySeasonLeaderboard',
  seasonLeaderboardLocal: 'hockeySeasonLeaderboardLocal',
  postSeasonLeaderboard: 'hockeyPostseasonLeaderboard',
  postSeasonLeaderboardLocal: 'hockeyPostseasonLeaderboardLocal',
};
